import React, { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import './Projects.css';

gsap.registerPlugin(ScrollTrigger);

const projects = [
  { id: '001', title: 'Scultura 3D Custom', category: 'Stampa 3D', year: '2026', color: '#bf00ff' },
  { id: '002', title: 'Incisione Corporate', category: 'Laser', year: '2026', color: '#00ccff' },
  { id: '003', title: 'Packaging UV Premium', category: 'Stampa UV', year: '2026', color: '#ff00aa' },
  { id: '004', title: 'Piattaforma E-commerce', category: 'Sviluppo Tech', year: '2026', color: '#00ff88' },
];

const Projects: React.FC = () => {
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    gsap.fromTo('.projects-title',
      { y: 60, opacity: 0 },
      { y: 0, opacity: 1, duration: 1, ease: 'power3.out',
        scrollTrigger: { trigger: '.projects-title', start: 'top 80%' } }
    );

    document.querySelectorAll('.project-item').forEach((item, i) => {
      gsap.fromTo(item,
        { x: i % 2 === 0 ? -60 : 60, opacity: 0 },
        { x: 0, opacity: 1, duration: 0.9, ease: 'power3.out',
          scrollTrigger: { trigger: item, start: 'top 85%' } }
      );
    });
  }, []);

  return (
    <section id="projects" className="projects" ref={sectionRef}>
      <div className="container">
        <div className="section-header projects-title">
          <span className="section-tag">— I nostri lavori</span>
          <h2 className="section-title">
            Progetti <span className="highlight">selezionati</span>
          </h2>
        </div>

        <div className="projects-list">
          {projects.map((p, i) => (
            <div className="project-item" key={p.id} style={{ '--accent': p.color } as any}>
              <div className="project-number">{p.id}</div>
              <div className="project-info">
                <span className="project-category" style={{ color: p.color }}>{p.category}</span>
                <h3 className="project-title">{p.title}</h3>
              </div>
              <div className="project-placeholder">
                <div className="placeholder-inner">
                  <span style={{ color: p.color }}>●</span>
                  <span>Coming soon</span>
                </div>
              </div>
              <div className="project-year">{p.year}</div>
              <div className="project-line" />
            </div>
          ))}
        </div>

        <div className="projects-cta">
          <p>Altri progetti in arrivo — stiamo documentando il nostro lavoro</p>
        </div>
      </div>
    </section>
  );
};

export default Projects;
